module.exports = __webpack_public_path__ + "img/T1D_rc-6.e46939c2.png";